import React from 'react'
import ZydusLogo from '../../../assets/images/zydus_logo.webp'
import BlueVectorBG from '../../../assets/images/blue_vector_bg.webp'
import KidneyImage from '../../../assets/images/kidney_risk_icon.webp'
import TestTubeImage from '../../../assets/images/blue_test_tubeIcon.webp'
import StopWatchImage from '../../../assets/images/yellow_stop_watch_icon.webp'
import Text from '../../atoms/Text'
import Button from '../../atoms/GoodFlipButton'
import ArrowIcon from '../../atoms/Arrow'
import ZydusHeader from '../../molecules/ZydusHeader'

const Data = [
  {
    icon: KidneyImage,
    title: '1 in 10 adults have silent kidney risk',
  },
  {
    icon: TestTubeImage,
    title:
      'Blood sugar & liver function show early warning signs of kidney disease',
  },
  {
    icon: StopWatchImage,
    title: 'Acting early prevents long-term complications',
  },
]

const BookDiagnosticBridge = ({ onClick = () => {} }) => {
  return (
    <div className="bg-gradient-to-t to-[#EEFFFF] from-[#FFFFFF] h-screen p-5 flex flex-col justify-between">
      <ZydusHeader />
      <div className="pb-28">
        <div className="relative flex items-center justify-center flex-col gap-2 min-h-[427px]">
          <img
            src={BlueVectorBG}
            alt="blue-vector-bg"
            className="absolute top-0 left-0 w-full h-full object-cover z-0"
          />
          <img
            src={ZydusLogo}
            alt="zydus-logo"
            className=" relative z-10 w-20 h-11"
          />
          <Text
            variant="display"
            size="small"
            className={'!text-center text-text-accent-teal-primary z-10'}
          >
            Book your kidney test now
          </Text>
          <Text
            variant="body"
            size="large"
            className={'text-text-secondary !text-center z-10'}
          >
            We've prepared a diagnostic test to help you spot early risk through
            key markers.
          </Text>
        </div>
        <div className="flex flex-col justify-between">
          <div className="bg-[#EEF4FF] p-4 rounded-xl">
            <Text
              variant="title"
              size="small"
              className={'text-text-accent-indigo-primary ml-4'}
            >
              Why early testing matters?
            </Text>
            <div className="bg-white mt-2 p-3 rounded-xl flex flex-col gap-2 items-start">
              {Data.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-center gap-4 "
                >
                  <img src={item.icon} alt={item.title} className="w-6 h-6" />
                  <Text
                    variant="label"
                    size="medium"
                    className={'text-text-primary'}
                  >
                    {item.title}
                  </Text>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-[#FFFDF5] border border-GOLD-500 px-4 py-2 mt-4 rounded-tl-xl rounded-br-xl">
            <Text
              variant="label"
              size="medium"
              className={'text-text-tertiary'}
            >
              It takes few mins to book. The impact lasts longer.
            </Text>
          </div>
        </div>
      </div>
      <div className="fixed bottom-0 w-full left-0 p-5">
        <div className="mt-4">
          <Button
            onClick={onClick}
            title={'See Diagnostic Tests'}
            className={'max-w-6xl mx-auto'}
            type="goodflip_primary"
            leftIcon={null}
            rightIcon={<ArrowIcon direction="right" color="#FFFFFF" />}
          />
        </div>
      </div>
    </div>
  )
}

export default BookDiagnosticBridge
